var map = {
	"./372.gif": 7620,
	"./802.gif": 2483,
	"./Free_Sample_By_Wix.jpeg": 540,
	"./Hourglass.gif": 1002,
	"./KongaPayPicture.png": 2949,
	"./SPS_1374-removebg-preview.png": 6021,
	"./aviv-rachmadian-7F7kEHj72MQ-unsplash.jpg": 3325,
	"./banner-02.jpg": 3735,
	"./banner-03.jpg": 9952,
	"./banner-04.jpg": 8990,
	"./banner-05.jpg": 9568,
	"./banner-07.jpg": 7654,
	"./banner-08-countdown.jpeg": 3648,
	"./blog-01.jpeg": 3587,
	"./blog-02.jpeg": 821,
	"./blog-03.jpeg": 8474,
	"./blog-heading.jpeg": 8469,
	"./chat.png": 553,
	"./coin.png": 5691,
	"./contact-heading-picture.jpeg": 7071,
	"./discover.png": 9989,
	"./dribbble.svg": 1511,
	"./erik-mclean-nfoRa6NHTbU-unsplash.jpg": 784,
	"./express.png": 4677,
	"./f-delivery.png": 6237,
	"./facebook.svg": 1693,
	"./fashionLogo.png.png": 8992,
	"./girl2 fashion.jpg": 5293,
	"./girls-fashion.jpg": 3859,
	"./icons8-check-1600.png": 5782,
	"./icons8-disappointed-100.png": 1705,
	"./icons8-slide-up-100.png": 4923,
	"./instagram.svg": 2770,
	"./linkedin.svg": 4296,
	"./logo.png": 6949,
	"./logo.svg": 9574,
	"./mastercard.png": 6010,
	"./mastercardPicture.png": 149,
	"./nguyen-dang-hoang-nhu-Nne2TxFHPyQ-unsplash.jpeg": 7124,
	"./paypal.png": 4165,
	"./shop-item-09-glasses.jpeg": 8693,
	"./vervecardPicture.png": 5552,
	"./visa.png": 8420,
	"./visacardPicture.png": 8818,
	"./waldemar-HmgSNpswOxM-unsplash.jpg": 7627,
	"./youtube.svg": 1242
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3646;